import { deleteFile, downloadPdf, getPreview, saveFile } from "@/api/ApplicationOrders/appOrdersDocs";
import { useMutation, useQuery } from "react-query";

// DOCS
export function useSaveDocument() {
	return useMutation(saveFile);
}

export function useDelDocument() {
	return useMutation(deleteFile);
}

export function useDownloadPdf(code) {
	return useMutation(downloadPdf, {
		onSuccess: (response) => {
			const href = URL.createObjectURL(response);

			const link = document.createElement("a");
			link.href = href;
			link.setAttribute("download", `OA_${code}.pdf`);
			document.body.appendChild(link);
			link.click();

			document.body.removeChild(link);
			URL.revokeObjectURL(href);
		},
	});
}

export function usePreviewPdf(code) {
	return useQuery(["OApreview", code], () => getPreview({ code }), {
		enabled: Boolean(code),
		cacheTime: 0,
		staleTime: 0,
	});
}
